
/**
 * Show the correct number of extra traveler inputs on the form
 *    - Listen to clicks on the travelers amount inputs
 *    - Show / Hide corresponding travelers groups
 *    - Update the travelers count on the overview section (accommodation and adventure form)
 *    - Update price on the inpage nav according to selected travelers amount
 */
export default function initExtraTravelers() {
  // Get Elements
  const defaultTraverlersAmount = 2;
  const extraTravelerInputs = document.querySelectorAll('.enquiry__extra-travelers-input');
  const extraTravelersGroups = document.querySelectorAll('.form__extra-traveler');
  const overviewPeopleCount = document.querySelector('#enquiryOverviewPeopleCount');
  const inpagePrice = document.querySelector('.booking-sticky-info__price-amount');
  let singleTravelerPrice = null;
  if (inpagePrice) {
    singleTravelerPrice =inpagePrice.getAttribute('singletravelerprice');
  }

  // Check if elements are available
  if (!extraTravelerInputs || !extraTravelersGroups) return;

  // Add click listeners to inputs
  extraTravelerInputs.forEach((travelerInput) => {
    travelerInput.addEventListener('click', () => {
      const selectedAmount = travelerInput.value;
      updateVisibleExtraTravelersGroups(+selectedAmount, extraTravelersGroups);

      if (overviewPeopleCount) {
        updateOverviewPeopleCount(overviewPeopleCount, selectedAmount);
      }

      if (inpagePrice && singleTravelerPrice) {
        updateInpagePrice(selectedAmount, singleTravelerPrice, inpagePrice);
      }
    });
  });

  // Show correct extra travelers when page loads
  updateVisibleExtraTravelersGroups(defaultTraverlersAmount, extraTravelersGroups);
}

/**
 * Show / Hide all travelers groups accordion to a select travelers amount
 *
 * @param amount
 * @param extraTravelersGroups
 */
function updateVisibleExtraTravelersGroups(amount, extraTravelersGroups) {
  extraTravelersGroups.forEach((travelersGroup, i) => {
    (i + 1) < amount
      ? travelersGroup.classList.remove('enquiry__extra-traveler--hide')
      : travelersGroup.classList.add('enquiry__extra-traveler--hide');
  })
}

/**
 * Update the travers amount on the overview section
 *
 * @param overviewPeopleCount
 * @param selectedAmount
 */
function updateOverviewPeopleCount(overviewPeopleCount, selectedAmount) {
  overviewPeopleCount.textContent = selectedAmount;
}

/**
 * Update the price on the fixed in page nav
 *
 * @param selectedAmount
 * @param singleTravelerPrice
 * @param inpagePrice
 */
function updateInpagePrice(selectedAmount, singleTravelerPrice, inpagePrice) {
  if (parseInt(selectedAmount, 10) !== 2 ) {
    inpagePrice.textContent = inpagePrice.dataset.outOfRangeText;
  } else {
    inpagePrice.textContent = `${selectedAmount * singleTravelerPrice} ${inpagePrice.dataset.currency}`;
  }
}
